import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const BreadCrumbTestimonials = ({ title, page, subtitle }) => {

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const responsivePadding = windowWidth <= 768 ? "140px 0 20px" : "200px 0 20px";

  return (
    <div className="breadcrum-area" style={{ padding: responsivePadding }}>
      <div className="container">
        <div className="breadcrumb testimonial-breadcrumb-wrapper">
          <div className="testimonial-breadcrumb-content">
            <ul className="list-unstyled">
              <li>
                <Link to={process.env.PUBLIC_URL + "/"} style={{color: "var(--color-text-dark)"}}>
                  Home
                </Link>
              </li>
              <li
                className="active"
                dangerouslySetInnerHTML={{ __html: page }}
              ></li>
            </ul>
            <h1
              className="title h2"
              dangerouslySetInnerHTML={{ __html: title }}
              style={{
                color: "var(--color-text-dark)",
              }}
            ></h1>
            <span className="subtitle-5" style={{color: "var(--color-text-dark)"}}>{subtitle}</span>
          </div>
          <div className="testimonial-gallery-btn-wrapper">
            <Link to="/gallery" className="btn testimonial-gallery-btn">
              View Gallery
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BreadCrumbTestimonials;